import { type PropsWithChildren, Fragment } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { keySecurityAuthorization } from '@/api/query-keys';
import { useQuery } from '@tanstack/react-query';
import Authorizor from '@/util/authorizor';
import Loading from '@/components/Loading';

export default function Authorized(props: PropsWithChildren) {
    const { getToken } = useAuth();
    const { data, isLoading } = useQuery({
        queryKey: keySecurityAuthorization(), 
        queryFn: async () => {
            return Authorizor.authorize(getToken);
        }
    });

    if (isLoading) {
        return <Loading />
    }

    if (!data) return null;
    
    return (
        <Fragment>
            { props.children }
        </Fragment>
    )
    
}